import { useWorkCalendar as useUiWorkCalendar } from '@srm/ui/hooks/useWorkCalendar';
import { loadWorkCalendar } from '@utils/workCalendar';

// Загрузчик приложения передаётся явно: виджету «Календарь» UiProvider не нужен.
export const useWorkCalendar = (enabled: boolean) => useUiWorkCalendar(enabled, loadWorkCalendar);
